import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tData Gaps\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-5" };
const _hoisted_11 = { class: "d-flex" };
const _hoisted_12 = { class: "clearfix" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { class: "btn-group pw100" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tThe end period will be 2 days before today\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_16 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_21 = {
    class: "checkbox-wrapper ms-3",
    style: { "width": "280px" }
};
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-1" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_27 = { class: "col-xs-12 col-sm-12" };
const _hoisted_28 = { class: "card bg-white data-grid data-gap-grid detached overflow-x-auto" };
const _hoisted_29 = { class: "table table-hover bottom0 pw100" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "4" }, "System / Strings")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "String"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "From"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "To")
    ])
], -1 /* HOISTED */);
const _hoisted_31 = { class: "font-weight-bold" };
const _hoisted_32 = { colspan: "4" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_35 = { key: 0 };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "4"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "There are no records matching your criteria.")
], -1 /* HOISTED */);
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = { class: "card bg-white data-grid data-gap-grid detached overflow-x-auto" };
const _hoisted_39 = { class: "table table-hover bottom0 pw100" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { colspan: "5" }, "System / Component / Blocks")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Block"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "From"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "To"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Reason")
    ])
], -1 /* HOISTED */);
const _hoisted_41 = { class: "font-weight-bold" };
const _hoisted_42 = { colspan: "5" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { class: "font-italic" };
const _hoisted_45 = {
    colspan: "5",
    style: { "padding-left": "30px" }
};
const _hoisted_46 = ["onClick"];
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_48 = { key: 0 };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "5"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "There are no records matching your criteria.")
], -1 /* HOISTED */);
const _hoisted_50 = [
    _hoisted_49
];
const _hoisted_51 = { class: "card bg-white data-grid data-gap-grid detached overflow-x-auto" };
const _hoisted_52 = { class: "table table-hover bottom0 pw100" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "System"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Measurement Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Component"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "From"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "To")
    ])
], -1 /* HOISTED */);
const _hoisted_54 = ["onClick"];
const _hoisted_55 = { colspan: "5" };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_58 = ["onClick"];
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("td", { colspan: "3" }, null, -1 /* HOISTED */);
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_63 = ["onClick"];
const _hoisted_64 = /*#__PURE__*/ _createElementVNode("td", { colspan: "2" }, null, -1 /* HOISTED */);
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_67 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("td", null, null, -1 /* HOISTED */);
const _hoisted_69 = { key: 0 };
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "6"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "There are no records matching your criteria.")
], -1 /* HOISTED */);
const _hoisted_71 = [
    _hoisted_70
];
const _hoisted_72 = { class: "clearfix" };
const _hoisted_73 = { class: "x_panel" };
const _hoisted_74 = { class: "x_content" };
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\tThis will schedule a background job to run once a day searching for data gaps between 9 days and 2 days before the current date/time.\r\n\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_76 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_77 = { class: "checkbox-wrapper bottom10" };
const _hoisted_78 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("label", { class: "mt-2 mb-0 me-2" }, "Time scheduled (UTC) ", -1 /* HOISTED */);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_81 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_82 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\tEmail addresses (separated by \";\")\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_83 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_84 = { class: "d-flex justify-content-between" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tSelect the Companies to Exclude\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_86 = { class: "float-end align-items-end" };
const _hoisted_87 = ["disabled"];
const _hoisted_88 = ["disabled"];
const _hoisted_89 = {
    class: "list-filter",
    style: { "height": "415px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_90 = { class: "list-options" };
const _hoisted_91 = ["onClick"];
const _hoisted_92 = { style: { "font": "700", "font-size": "16px" } };
const _hoisted_93 = { class: "float-end float-start-sm" };
const _hoisted_94 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_95 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_b_tabs = _resolveComponent("b-tabs");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.companyId,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.companyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "select a company",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.siteId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.siteId) = $event)),
                                options: _ctx.sitesFiltered,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All sites",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                (!_ctx.showDatePickers)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                                return (_openBlock(), _createBlock(_component_b_button, {
                                                    class: "pw100",
                                                    disabled: _ctx.working,
                                                    key: idx,
                                                    variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                                    onClick: ($event) => (_ctx.setDateFilterOption(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_15
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.showDatePickers)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _createVNode(_component_b_input_group, {
                                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_flat_pickr, {
                                                        class: "form-control",
                                                        modelValue: _ctx.query.startTime,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.startTime) = $event)),
                                                        config: _ctx.datePickerConfig,
                                                        placeholder: "From date",
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_input_group_append, null, {
                                                        default: _withCtx(() => [
                                                            _hoisted_18
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["class"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createVNode(_component_b_input_group, {
                                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_flat_pickr, {
                                                        class: "form-control",
                                                        modelValue: _ctx.query.endTime,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.endTime) = $event)),
                                                        config: _ctx.datePickerConfig,
                                                        placeholder: "Until date",
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_input_group_append, null, {
                                                        default: _withCtx(() => [
                                                            _hoisted_20,
                                                            _createTextVNode(),
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-secondary",
                                                                onClick: _cache[4] || (_cache[4] =
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                            }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["class"])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_b_form_checkbox, {
                                    modelValue: _ctx.query.includeMeasurements,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.includeMeasurements) = $event)),
                                    size: "lg"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tInclude Measurements\r\n\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_b_button, {
                                class: "w-100",
                                variant: "primary bottom10",
                                onClick: _ctx.search
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_24
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_b_button, {
                                class: "w-100",
                                variant: "primary bottom10",
                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.showConfig()))
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_26
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_b_tabs, {
                        modelValue: _ctx.activeTab,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.activeTab) = $event)),
                        "nav-wrapper-class": "x_title tabs",
                        "content-class": "x_content"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_component_b_tab, {
                                    key: "stringSnapshots",
                                    title: "String Snapshots"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("table", _hoisted_29, [
                                                _hoisted_30,
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedStringGaps, (group, systemId) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, { key: systemId }, [
                                                            _createCommentVNode(" Group summary row "),
                                                            _createTextVNode(),
                                                            _createElementVNode("tr", _hoisted_31, [
                                                                _createElementVNode("td", _hoisted_32, [
                                                                    _createElementVNode("i", {
                                                                        class: _normalizeClass(['fa', _ctx.expandedStringGroups[systemId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                        style: { "cursor": "pointer", "margin-right": "10px" },
                                                                        onClick: ($event) => (_ctx.expandedStringGroups[systemId] = !_ctx.expandedStringGroups[systemId])
                                                                    }, null, 10 /* CLASS, PROPS */, _hoisted_33),
                                                                    _createTextVNode(" " + _toDisplayString(group.systemName) + " (" + _toDisplayString(group.items.length) + " entries)\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                ])
                                                            ]),
                                                            _createTextVNode(),
                                                            _createCommentVNode(" Expanded detail rows "),
                                                            _createTextVNode(),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expandedStringGroups[systemId] ? group.items : [], (item) => {
                                                                return (_openBlock(), _createElementBlock("tr", {
                                                                    key: item.gapStart + item.componentName
                                                                }, [
                                                                    _hoisted_34,
                                                                    _createTextVNode(),
                                                                    _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapStart)), 1 /* TEXT */),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapEnd)), 1 /* TEXT */)
                                                                ]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ], 64 /* STABLE_FRAGMENT */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.noStringSnapshotData)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_35, _hoisted_37))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode(),
                                _createVNode(_component_b_tab, {
                                    key: "blockSnapshots",
                                    title: "Block Snapshots"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("table", _hoisted_39, [
                                                _hoisted_40,
                                                _createTextVNode(),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedBlockGapsBySystem, (systemGroup, systemId) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, { key: systemId }, [
                                                            _createCommentVNode(" System summary row "),
                                                            _createTextVNode(),
                                                            _createElementVNode("tr", _hoisted_41, [
                                                                _createElementVNode("td", _hoisted_42, [
                                                                    _createElementVNode("i", {
                                                                        class: _normalizeClass(['fa', _ctx.expandedBlockSystems[systemId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                        style: { "cursor": "pointer", "margin-right": "10px" },
                                                                        onClick: ($event) => (_ctx.toggleBlockSystem(systemId))
                                                                    }, null, 10 /* CLASS, PROPS */, _hoisted_43),
                                                                    _createTextVNode(" " + _toDisplayString(systemGroup.systemName) + " (" + _toDisplayString(systemGroup.totalCount) + " entries)\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                ])
                                                            ]),
                                                            _createTextVNode(),
                                                            _createCommentVNode(" Component groups under expanded system "),
                                                            _createTextVNode(),
                                                            (_ctx.expandedBlockSystems[systemId])
                                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(systemGroup.components, (componentGroup, componentId) => {
                                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: componentId }, [
                                                                        _createCommentVNode(" Component summary row "),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("tr", _hoisted_44, [
                                                                            _createElementVNode("td", _hoisted_45, [
                                                                                _createElementVNode("i", {
                                                                                    class: _normalizeClass(['fa', _ctx.expandedBlockComponents[componentId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                                    style: { "cursor": "pointer", "margin-right": "10px" },
                                                                                    onClick: ($event) => (_ctx.toggleBlockComponent(componentId))
                                                                                }, null, 10 /* CLASS, PROPS */, _hoisted_46),
                                                                                _createTextVNode(" " + _toDisplayString(componentGroup.componentName) + " (" + _toDisplayString(componentGroup.items.length) + " entries)\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                            ])
                                                                        ]),
                                                                        _createTextVNode(),
                                                                        _createCommentVNode(" Expanded block-level detail rows "),
                                                                        _createTextVNode(),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expandedBlockComponents[componentId] ? componentGroup.items : [], (item) => {
                                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                                key: item.gapStart + item.componentName
                                                                            }, [
                                                                                _hoisted_47,
                                                                                _createTextVNode(),
                                                                                _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                                _createTextVNode(),
                                                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapStart)), 1 /* TEXT */),
                                                                                _createTextVNode(),
                                                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapEnd)), 1 /* TEXT */),
                                                                                _createTextVNode(),
                                                                                _createElementVNode("td", null, _toDisplayString(item.reason), 1 /* TEXT */)
                                                                            ]));
                                                                        }), 128 /* KEYED_FRAGMENT */))
                                                                    ], 64 /* STABLE_FRAGMENT */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 64 /* STABLE_FRAGMENT */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.noBlockSnapshotData)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_48, _hoisted_50))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode(),
                                ((_a = _ctx.data) === null || _a === void 0 ? void 0 : _a.includesMeasurements)
                                    ? (_openBlock(), _createBlock(_component_b_tab, {
                                        key: "measurements",
                                        title: "Measurements"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("table", _hoisted_52, [
                                                    _hoisted_53,
                                                    _createTextVNode(),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedMeasurementGaps, (systemGroup, systemId) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, { key: systemId }, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("td", null, [
                                                                        _createElementVNode("i", {
                                                                            class: _normalizeClass(['fa', _ctx.expandedMeasurementSystems[systemId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                            onClick: ($event) => (_ctx.toggleMeasurementSystem(Number(systemId))),
                                                                            style: { "cursor": "pointer" }
                                                                        }, null, 10 /* CLASS, PROPS */, _hoisted_54)
                                                                    ]),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("td", _hoisted_55, [
                                                                        _createElementVNode("strong", null, _toDisplayString(systemGroup.systemName), 1 /* TEXT */),
                                                                        _createTextVNode(" (" + _toDisplayString(systemGroup.totalCount) + " entries)", 1 /* TEXT */)
                                                                    ])
                                                                ]),
                                                                _createTextVNode(),
                                                                (_ctx.expandedMeasurementSystems[systemId])
                                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(systemGroup.measurements, (measurementGroup, measurementTypeId) => {
                                                                        return (_openBlock(), _createElementBlock(_Fragment, { key: measurementTypeId }, [
                                                                            _createElementVNode("tr", null, [
                                                                                _hoisted_56,
                                                                                _createTextVNode(),
                                                                                _hoisted_57,
                                                                                _createTextVNode(),
                                                                                _createElementVNode("td", null, [
                                                                                    _createElementVNode("i", {
                                                                                        class: _normalizeClass(['fa', _ctx.expandedMeasurementTypes[measurementTypeId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                                        onClick: ($event) => (_ctx.toggleMeasurementType(Number(measurementTypeId))),
                                                                                        style: { "cursor": "pointer" }
                                                                                    }, null, 10 /* CLASS, PROPS */, _hoisted_58),
                                                                                    _createTextVNode(),
                                                                                    _createElementVNode("strong", null, _toDisplayString(measurementGroup.measurementName), 1 /* TEXT */)
                                                                                ]),
                                                                                _createTextVNode(),
                                                                                _hoisted_59
                                                                            ]),
                                                                            _createTextVNode(),
                                                                            (_ctx.expandedMeasurementTypes[measurementTypeId])
                                                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(measurementGroup.components, (componentGroup, componentId) => {
                                                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: componentId }, [
                                                                                        _createElementVNode("tr", null, [
                                                                                            _hoisted_60,
                                                                                            _createTextVNode(),
                                                                                            _hoisted_61,
                                                                                            _createTextVNode(),
                                                                                            _hoisted_62,
                                                                                            _createTextVNode(),
                                                                                            _createElementVNode("td", null, [
                                                                                                _createElementVNode("i", {
                                                                                                    class: _normalizeClass(['fa', _ctx.expandedMeasurementComponents[componentId] ? 'fa-minus-square' : 'fa-plus-square']),
                                                                                                    onClick: ($event) => (_ctx.toggleMeasurementComponent(Number(componentId))),
                                                                                                    style: { "cursor": "pointer" }
                                                                                                }, null, 10 /* CLASS, PROPS */, _hoisted_63),
                                                                                                _createTextVNode(),
                                                                                                _createElementVNode("strong", null, _toDisplayString(componentGroup.componentName), 1 /* TEXT */)
                                                                                            ]),
                                                                                            _createTextVNode(),
                                                                                            _hoisted_64
                                                                                        ]),
                                                                                        _createTextVNode(),
                                                                                        (_ctx.expandedMeasurementComponents[componentId])
                                                                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(componentGroup.items, (item, index) => {
                                                                                                return (_openBlock(), _createElementBlock("tr", {
                                                                                                    key: `gap-${systemId}-${measurementTypeId}-${componentId}-${index}`
                                                                                                }, [
                                                                                                    _hoisted_65,
                                                                                                    _createTextVNode(),
                                                                                                    _hoisted_66,
                                                                                                    _createTextVNode(),
                                                                                                    _hoisted_67,
                                                                                                    _createTextVNode(),
                                                                                                    _hoisted_68,
                                                                                                    _createTextVNode(),
                                                                                                    _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapStart, true)), 1 /* TEXT */),
                                                                                                    _createTextVNode(),
                                                                                                    _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.gapEnd, true)), 1 /* TEXT */)
                                                                                                ]));
                                                                                            }), 128 /* KEYED_FRAGMENT */))
                                                                                            : _createCommentVNode("v-if", true)
                                                                                    ], 64 /* STABLE_FRAGMENT */));
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                                : _createCommentVNode("v-if", true)
                                                                        ], 64 /* STABLE_FRAGMENT */));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                    : _createCommentVNode("v-if", true)
                                                            ], 64 /* STABLE_FRAGMENT */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("tfoot", null, [
                                                        (_ctx.noMeasurementData)
                                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_69, _hoisted_71))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "data-gap-scheduler",
            modelValue: _ctx.showConfigModal,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.showConfigModal) = $event)),
            "header-bg-variant": "normal",
            size: "lg"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tData Gap Scheduler\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_93, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [
                            _hoisted_94,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_95,
                            _createTextVNode(" Cancel\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                    _hoisted_75,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("div", _hoisted_77, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.settingsModel.enabled,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.settingsModel.enabled) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tEnabled\r\n\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_78, [
                                        _hoisted_79,
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['top_search']),
                                            style: { "width": "150px" }
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    class: "form-control",
                                                    modelValue: _ctx.settingsModel.timeScheduled,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.settingsModel.timeScheduled) = $event)),
                                                    config: _ctx.timePickerConfig,
                                                    placeholder: "Time"
                                                }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _hoisted_80
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_81, [
                                        _hoisted_82,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_input, {
                                            type: "text",
                                            maxlength: "150",
                                            modelValue: _ctx.settingsModel.emailAddresses,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.settingsModel.emailAddresses) = $event)),
                                            modelModifiers: { trim: true }
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_83, [
                                        _createElementVNode("div", _hoisted_84, [
                                            _hoisted_85,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_86, [
                                                _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedCompaniesCount()), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input ms-3",
                                                    style: { "margin-bottom": "11px" },
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.showOnlyCompaniesSelected) = $event)),
                                                    disabled: (_ctx.selectedCompaniesCount() == 0)
                                                }, null, 8 /* PROPS */, _hoisted_87), [
                                                    [_vModelCheckbox, _ctx.showOnlyCompaniesSelected]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    disabled: _ctx.selectedCompaniesCount() == 0
                                                }, " Show only selected", 8 /* PROPS */, _hoisted_88)
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_89, [
                                            _createElementVNode("div", _hoisted_90, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (item) => {
                                                    return (_openBlock(), _createElementBlock("div", null, [
                                                        _withDirectives((_openBlock(), _createElementBlock("div", {
                                                            class: _normalizeClass(['list-option', _ctx.isCompanySelected(item) ? 'selected-option' : '']),
                                                            onClick: _withModifiers(($event) => (_ctx.selectCompany(item)), ["prevent"]),
                                                            key: item.value,
                                                            style: { "text-align": "left", "padding": "5px" }
                                                        }, [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("span", _hoisted_92, _toDisplayString(item.text), 1 /* TEXT */)
                                                            ])
                                                        ], 10 /* CLASS, PROPS */, _hoisted_91)), [
                                                            [_vShow, _ctx.canShowCompany(item)]
                                                        ])
                                                    ]));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
